<template functional>
  <a :class="[`c-base-link-external ${props.variant ? `c-base-link-external--${props.variant}` : ''} ${data.staticClass || ''}`]" :href="props.link" :target="props.target">
    {{ props.content }}
  </a>
</template>

<script>
export default {
  name: 'BaseLinkExternal',

  props: {
    link: {
      required: true,
      type: String
    },
    content: {
      required: true,
      type: String
    },
    target: {
      type: String,
      default: '_self',
      validator: function (value) {
        return ['_blank', '_self'].includes(value)
      }
    },
    variant: {
      type: String,
      required: false
    }
  }
}
</script>
